import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { Zap } from 'lucide-react'

/**
 * Landing page after OAuth redirect (Slack, Teams, SSO).
 * Reads ?token= and ?refresh_token= from URL, stores both, fetches /api/me and redirects to dashboard.
 */
export function AuthCallbackPage() {
  const [params] = useSearchParams()
  const login = useAuthStore(s => s.login)
  const navigate = useNavigate()

  useEffect(() => {
    const token = params.get('token')
    if (!token) {
      navigate('/login')
      return
    }
    const refreshToken = params.get('refresh_token') ?? undefined

    login(token, refreshToken).then(() => navigate('/')).catch(() => navigate('/login'))
  }, [params, login, navigate])

  return (
    <div className="min-h-screen bg-warm-base flex flex-col items-center justify-center gap-4">
      <div className="w-14 h-14 rounded-2xl bg-brand-teal flex items-center justify-center shadow-glow-teal animate-pulse">
        <Zap size={22} className="text-white" />
      </div>
      <p className="text-ink-muted text-sm">Signing you in…</p>
    </div>
  )
}
